<template>
  <div
    class="flex items-center gap-2 p-4 w-full"
    :class="{ 'opacity-50 cursor-not-allowed': isDisabled }"
  >
    <ThemeImage
      :icon="getVendorIcon"
      :alt="mailbox.vendor?.toLowerCase()"
      class="size-4"
    />
    <div class="flex justify-between w-full items-center">
      <span class="text-sm">{{ mailbox.email }}</span>
      <span
        v-if="mailbox.status === MAILBOX_STATUS.DISCONNECTED"
        class="text-sm"
        style="color: var(--paused-icon)"
      >
        Disconnected
      </span>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import ThemeImage from "@/src/components/ThemeImage.vue";
import { emailVendorIcons } from "@/src/constants/settingConstants.js";
import { MAILBOX_STATUS } from "../constants/mailboxConstants";

const props = defineProps({
  value: {
    type: Object,
    required: true,
  },
  row: {
    type: Object,
    required: true,
  },
});

const mailbox = computed(() => props.row);

const isDisabled = computed(() => {
  return mailbox.value.status === MAILBOX_STATUS.DISCONNECTED;
});

const getVendorIcon = computed(() => {
  const vendor = mailbox.value.vendor;
  return emailVendorIcons[vendor] || emailVendorIcons.SMTP;
});
</script>
